import React from 'react'

import ProjectSupplierInvoiceListItem from './ProjectSupplierInvoiceListItem'

const ProjectSupplierInvoiceList = (props) => {
    return (

        <div className="d-flex flex-column">
            {
                props.invoices.map((invoice, index) => <ProjectSupplierInvoiceListItem canDownload={props.canDownload}
                                                                               canRemove={props.canRemove}
                                                                               canEdit={props.canEdit}
                                                                               project_id={props.project_id} key={index}
                                                                               onEdit={(invoiceID) => {
                                                                                   if(props.onEdit) props.onEdit(invoiceID)
                                                                               }}
                                                                               invoice={invoice}/>)
            }
        </div>


    )
}

export default ProjectSupplierInvoiceList